const getTomorrowDate = () => {
	const today = new Date();
	today.setDate(today.getDate() + 1);
	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

const getTodayDate = () => {
	const today = new Date();
	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

const getOneYearAgo = () => {
	const today = new Date();
	today.setDate(today.getDate() - 365);
	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

export const queries = {
	videos: {
		content: 'videos',
		types: {
			0: 'video',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			active: 1,
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 20
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: 'category',
					},
					status: 'published'
				}],
				images: {
					filters: [{
						types: {
							0: 'thumb'
						},
					}],
				},
			},
			images: {
				filters: [{
					types: {
						0: 'cover',
						1: 'home_cover',
						2: 'thumb',
						3: 'cover_thumb'
					},
				}],
			},
			clips: {},
			videos: {},
			categories: {}
		}],
	},
	video: {
		content: 'video',
		types: {
			0: 'video',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published'
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: 'category',
						1: 'film_collection',
						2: 'model',
						3: 'preroll'
					},
					status: 'published'
				}],
				include: [{
					resources: {
						filters: [{
							types: {
								0: 'video'
							},
							status: 'published'
						}],
						include: [{
							images: {
								filters: [{
									types: {
										0: 'cover',
										1: 'home_cover',
										2: 'thumb',
										3: 'cover_thumb'
									},
								}],
							},	
						}]
					},
					images: {
						filters: [{
							types: {
								0: 'cover',
								1: 'home_cover',
								2: 'thumb',
								3: 'cover_thumb'
							},
						}],
					},
					videos: {},
					extra: {}
				}],
			},
			images: {
				filters: [{
					types: {
						0: 'cover',
						1: 'home_cover',
						2: 'thumb',
						3: 'cover_thumb'
					},
				}],
			},
			related: {
				filters: [{
					types: {
						0: 'video',
					},
					status: 'published'
				}],
				include: [{
					images: {
						filters: [{
							types: {
								0: 'cover',
								1: 'thumb'
							}
						}],
					}
				}]
			},
			seo: {},
			images: {},
			clips: {},
			videos: {},
			categories: {},
			models: {},
			extra: {},
		}],
	},
	populairModels: {
		content: 'populairModels',
		rkey: 'geile_meiden',
		types: {
			0: 'model',
		},
		sort: {
			recommended_at: "desc"
		},
		filters: {
			status: "published"
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: "model_thumb",
						1: "square"
					}
				}]
			}
		}],
	},
	shortModels: {
		content: 'shortModels',
		short: true,
		types: {
			0: 'model',
		},
		sort: {
			recommended_at: "desc"
		},
		filters: {
			status: "published"
		},
		pagination: {
			page: 1,
			per_page: 500
		},
	},
	models: {
		content: 'models',
		types: {
			0: 'model',
		},
		sort: {
			published_at: "desc"
		},
		filters: {
			status: "published"
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: "model_thumb",
						1: "square"
					}
				}]
			}
		}],
	},
	model: {
		content: 'model',
		types: {
			0: 'model',
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			resources: {
				filters: {
					status: 'published'
				},
				pagination: {
					page: 1,
					per_page: 12
				},
				sort: {
					published_at: "desc"
				},
				include: [{
					images: {
						filters: [{
							types: {
								0: 'thumb'
							}
						}]
					},
					seo: {},
					videos: {},
					clips: {},
					extra: {}
				}]
			},
			seo: {},
			images: {
				filters: [{
					types: {
						0: "model_thumb",
						1: "square"
					}
				}],
			},
			clips: {},
			videos: {},
			extra: {}
		}],
	},
	randomModels: {
		content: 'randomModels',
		types: {
			0: 'model',
		},
		sort: {
			shuffle: "desc"
		},
		filters: {
			status: "published"
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: "video"
					},
					status: "published"
				}],
			},
			images: {
				filters: [{
					types: {
						0: "model_thumb",
						1: "square"
					}
				}]
			}
		}],
	},
	videoOfTheWeek: {
		content: 'videoOfTheWeek',
		types: {
			0: 'video',
		},
		sort: {
			published_at: 'desc'
		},
		filters: {
			status: 'published',
			labels: ['video_of_the_week']
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile'
					},
				}],
			},
			categories: {},
			clips: {},
			videos: {}
		}],
	},
	highlightVideos: {
		content: 'highlightVideos',
		types: {
			0: 'video',
		},
		sort: {
			published_at: 'desc'
		},
		filters: {
			status: 'published',
			labels: ['highlight_videos']
		},
		pagination: {
			page: 1,
			per_page: 3
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile'
					},
				}],
			},
			categories: {},
			clips: {},
			videos: {}
		}],
	},
	videoForYou: {
		content: 'videoForYou',
		types: {
			0: 'video',
		},
		sort: {
			published_at: 'desc'
		},
		filters: {
			status: 'published',
			labels: ['home_promo']
		},
		pagination: {
			page: 1,
			per_page: 1
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: 'category',
					},
					status: 'published'
				}],
				images: {
					filters: [{
						types: {
							0: 'thumb'
						},
					}],
				},
			},
			images: {
				filters: [{
					types: {
						0: 'cover_thumb',
						1: 'home_cover',
						2: 'thumb'
					},
				}],
			},
			videos: {},
			categories: {},
			clips: {}
		}],
	},
	seksfilmsPromo: {
		content: 'seksfilmsPromo',
		types: {
			0: 'video',
		},
		sort: {
			published_at: 'desc'
		},
		filters: {
			status: 'published',
			labels: ['seksfilms_promo']
		},
		pagination: {
			page: 1,
			per_page: 1
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: 'category',
					},
					status: 'published'
				}],
				images: {
					filters: [{
						types: {
							0: 'thumb'
						},
					}],
				},
			},
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'home_cover',
						2: 'cover'
					},
				}],
			},
			videos: {},
			categories: {},
			clips: {}
		}],
	},
	recommendedVideos: {
		content: 'recommendedVideos',
		rkey: 'de_beste_sexfilms',
		types: {
			0: 'video',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			active: 1,
			recurring_from: { 0: 'before,' + getTodayDate() },
			products: {
				0: 'paid'	
			}
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile'
					},
				}],
			},
			videos: {},
			clips: {}
		}],
	},
	newestRecurringVideos: {
		content: 'newestRecurringVideos',
		rkey: 'nieuw_in_direct',
		types: {
			0: 'video',
		},
		sort: {
			recurring_from: 'desc'
		},
		filters: {
			status: 'published',
			recurring_from: { 0: 'before,' + getTodayDate() },
			products: {
				0: 'paid'	
			}
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile'
					},
				}],
			},
			videos: {},
			clips: {}
		}],
	},
	freeVideos: {
		content: 'freeVideos',
		rkey: 'gratis_sexfilms',
		types: {
			0: 'video',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published',
			products: {
				0: 'free'	
			}
		},
		pagination: {
			page: 1,
			per_page: 20
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile'
					},
				}],
			},
			videos: {},
			clips: {}
		}],
	},
	randomVideos: {
		content: 'randomVideos',
		rkey: 'uit_een_oude_doos',
		types: {
			0: 'video',
		},
		sort: {
			random: 'desc'
		},
		filters: {
			status: 'published',
			recurring_from: { 0: 'before,' + getOneYearAgo() }, 
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile'
					},
				}],
			},
			videos: {},
			clips: {}
		}],
	},
	votwFree: {
		content: 'votwFree',
		rkey: 'gratis_sexfilms_kijken',
		types: {
			0: 'video',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published',
			products: {
				0: 'free'	
			}
		},
		pagination: {
			page: 1,
			per_page: 3
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile'
					},
				}],
			},
			videos: {},
			clips: {}
		}],
	},
	mostRecent: {
		content: 'mostRecent',
		rkey: 'nu_in_premiere',
		types: {
			0: 'video',
		},
		sort: {
			published_at: 'desc'
		},
		filters: {
			active: 1,
			products: {
				0: 'paid'	
			}
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile'
					},
				}],
			},
			videos: {},
			clips: {}
		}],
	},
	planned: {
		content: 'planned',
		rkey: 'binnenkort_in_direct',
		types: {
			0: 'video',
		},
		sort: {
			recurring_from: 'asc',
		},
		filters: {
			status: 'published',
			recurring_from: { 0: 'after,' + getTomorrowDate() }

		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile',
					},
				}],
			},
			videos: {},
			clips: {}
		}],
	},
	tempFree: {
		content: 'tempFree',
		rkey: 'tijdelijk_gratis',
		types: {
			0: 'video',
		},
		sort: {
			published_at: 'desc'
		},
		filters: {
			status: 'published',
			labels: ['temporary_free']
		},
		pagination: {
			page: 1,
			per_page: 1
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: 'category',
					},
					status: 'published'
				}],
				images: {
					filters: [{
						types: {
							0: 'thumb'
						},
					}],
				},
			},
			images: {
				filters: [{
					types: {
						0: 'cover',
						1: 'home_cover',
						2: 'cover_thumb'
					},
				}],
			},
			videos: {},
			categories: {},
			labels: {}
		}],
	},
	topVideos: {
		content: 'topVideos',
		rkey: 'direct_top_10',
		types: {
			0: 'video',
		},
		sort: {
			most_watched: 'week'
		},
		filters: {
			active: 1,
			recurring_from: { 0: 'before,' + getTodayDate() },
			products: {
				0: 'paid'	
			}
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile'
					},
				}],
			},
			videos: {},
			clips: {}
		}],
	},
	allinVideos: {
		content: 'allinVideos',
		types: {
			0: 'video',
		},
		sort: {
			recurring_from: 'desc'
		},
		filters: {
			active: 1,
			recurring_from: { 0: 'before,' + getTodayDate() },
			products: {
				0: 'paid'	
			}
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile'
					},
				}],
			},
			videos: {},
			clips: {}
		}],
	},
	shows: {
		content: 'shows',
		rkey: 'sexy_series',
		types: {
			0: 'show',
		},
		sort: {
			published_at: "desc"
		},
		filters: {
			status: "published"
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: "episode"
					},
					status: "published"
				}],
				include: [{
					images: {},
					seo: {},
					clips: {},
					videos: {},
					extra: {}
				}]
			},
			images: {
				filters: [{
					types: {
						0: "thumb"
					}
				}]
			},
			clips: {}
		}],
	},
	show: {
		content: 'show',
		types: {
			0: 'show',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: 'video',
						1: 'model',
					},
					status: 'publishedandplanned'
				}],
				pagination: {
					page: 1,
					per_page: 12
				},
				include: [{
					images: {
						filters: [{
							types: {
								0: 'thumb',
								1: 'square'
							},
						}],
					},
					videos: {},
					audios: {},
					clips: {},
					extra: {},
				}]
			},
			images: {
				filters: [{
					types: {
						0: 'thumb'
					},
				}],
			},
			categories: {},
			videos: {}
		}],
	},
	episode: {
		content: 'episode',
		types: {
			0: 'episode',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: 'show',
					},
					status: 'published'
				}],
				images: {
					filters: [{
						types: {
							0: 'thumb'
						},
					}],
				},
				include: [{
					resources: {
						filters: [{
							types: {
								0: 'episode',
							},
							status: 'published'
						}],
						include: [{
							videos: {},
							extra: {}
						}]
					},
				}]
			},
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'album'
					},
				}],
			},
			categories: {},
			videos: {},
			extra: {}
		}],
	},
	category: {
		content: 'category',
		types: {
			0: 'category',
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: 'video',
					},
					status: 'published'
				}],
				sort: {
					published_at: "desc"
				},
				pagination: {
					page: 1,
					per_page: 12
				},
				include: [{
					images: {
						filters: [{
							types: {
								0: 'thumb'
							},
						}],
					},
					clips: {},
				}]
			},
			images: {
				filters: [{
					types: {
						0: 'thumb'
					},
				}],
			},
			categories: {}
		}],
	},
	allCategories: {
		content: 'allCategories',
		types: {
			0: 'category',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 50
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb'
					},
				}],
			},
		}]
	},
	categories: {
		content: 'categories',
		rkey: 'genres',
		types: {
			0: 'category',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb'
					},
				}],
			},
		}]
	},
	populairCategories: {
		content: 'populairCategories',
		rkey: 'genres_home',
		types: {
			0: 'category',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb'
					},
				}],
			},
		}]
	},
	randomCategories: {
		content: 'randomCategories',
		rkey: 'willekeurige_genres',
		types: {
			0: 'category',
		},
		sort: {
			random: 'desc'
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: "video"
					},
					status: "published"
				}],
			},
		}]
	},
	tag: {
		content: 'tag',
		types: {
			0: 'category',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: 'video',
					},
					status: 'published'
				}],
				images: {
					filters: [{
						types: {
							0: 'thumb'
						},
					}],
				},
			},
		}],
	},
	collections: {
		content: 'film_collections',
		types: {
			0: 'film_collection',
		},
		sort: {
			random: 'desc'
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 3
		},
		include: [{
			resources: {
				filters: [{
					types: {
						0: 'video',
					},
					status: 'published'
				}],
			},
			images: {},
			categories: {}
		}],
	},
	search : {
		content: 'search',
		types: {
			0: 'video',
          // 1: 'model',
          // 2: 'category'
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published',
		},
		search: {
			all: ''
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			seo: {},
			images: {
				filters: [{
					types: {
						0: 'thumb',
						2: 'square',
						3: 'cover',
						4: 'cover_thumb'
					}
				}],
			},
			clips: {},
			extra: {}
		}]
	},
	providers : {
		content: 'providers',
		rkey: 'tv_zender_ontvangen',
		types: {
			0: 'provider'
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published',
		},
		search: '',
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			seo: {},
			images: {
				filters: [{
					types: {
						0: 'thumb',
					}
				}],
			},
			clips: {},
			extra: {}
		}]
	},
	preroll: {
		content: 'preroll',
		types: {
			0: 'preroll',
		},
		sort: {
			random: 'desc',
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 10
		},
		include: {
			videos: {},
			extra: {}
		}
	},
	faqs: {
		content: 'faqs',
		rkey: 'veelgestelde_vragen',
		types: {
			0: 'faq',
		},
		sort: {
			recommended_at: 'desc',
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 20
		}
	},
	sexlinks: {
		content: 'sexlinks',
		rkey: 'sexlink_partners',
		types: {
			0: 'friend',
		},
		sort: {
			recommended_at: 'desc',
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 20
		}
	},
	news: {
		content: 'news',
		rkey: 'nieuws',
		types: {
			0: 'news',
		},
		sort: {
			recommended_at: 'desc',
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 20
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
					}
				}],
			},
			videos: {},
			extra: {}
		}],
	},
	newsitem: {
		content: 'newsitem',
		types: {
			0: 'news',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb'
					},
				}],
			},
			videos: {},
			related: {},
			extra: {}
		}],
	},
	privatevideos: {
		content: 'privatevideos',
		rkey: 'gluren_naar_privefilmpjes',
		types: {
			0: 'private',
		},
		sort: {
			random: 'desc',
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
					}
				}],
			},
			videos: {},
			extra: {}
		}]
	},
	privatevideo: {
		content: 'privatevideo',
		types: {
			0: 'private',
		},
		sort: {
			recommended_at: 'desc'
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 12
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb'
					},
				}],
			},
			videos: {},
			related: {},
			extra: {}
		}],
	},
	spotlight: {
		content: 'spotlight',
		rkey: 'spotlight',
		types: {
			0: 'spotlight',
		},
		sort: {
			published_at: 'desc',
		},
		filters: {
			status: 'published'
		},
		pagination: {
			page: 1,
			per_page: 1
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
					}
				}],
			},
			extra: {}
		}]
	},
	popup: {
		content: 'popup',
		rkey: 'popup',
		types: {
			0: 'popup',
		},
		sort: {
			published_at: 'desc',
		},
		filters: {
			status: 'published',
			active: 1
		},
		pagination: {
			page: 1,
			per_page: 1
		},
		include: [{
			images: {
				filters: [{
					types: {
						0: 'thumb',
						1: 'thumb_mobile',
					}
				}],
			},
			extra: {}
		}]
	},
};